"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsSOS_RTK = NotificationsSOS_RTK;
const react_1 = __importStar(require("react"));
require("bootstrap/dist/css/bootstrap.min.css");
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Badge_1 = __importDefault(require("react-bootstrap/Badge"));
const Offcanvas_1 = __importDefault(require("react-bootstrap/Offcanvas"));
const ListGroup_1 = __importDefault(require("react-bootstrap/ListGroup"));
const CloseButton_1 = __importDefault(require("react-bootstrap/CloseButton"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const io5_1 = require("react-icons/io5");
const md_1 = require("react-icons/md");
const bs_1 = require("react-icons/bs");
const fa6_1 = require("react-icons/fa6");
const react_router_dom_1 = require("react-router-dom");
const sos_notifications_api_1 = require("../../utils/api/sos-notifications/sos-notifications.api");
const useWebSocket_1 = __importDefault(require("../../hooks/useWebSocket"));
const useRealtimeChannel_1 = __importDefault(require("../../hooks/useRealtimeChannel"));
const useTitleBadge_1 = require("../../hooks/useTitleBadge");
const axios_1 = __importDefault(require("axios"));
const http_1 = require("../../utils/http");
const hook_1 = require("../../redux/hook");
function toUIStatus(r) {
    const s = (r.status || '').toLowerCase();
    const isTraite = !!r.traited_at ||
        ['traite', 'traité', 'termine', 'terminé', 'done', 'completed', 'traited'].includes(s);
    if (isTraite)
        return 'traited';
    if (r.is_archive === 1)
        return 'archive';
    if (r.is_read === 1)
        return 'lu';
    return 'nouveau';
}
function mapTowToNotif(r) {
    var _a, _b, _c, _d;
    return {
        id: r.id,
        phone: r.phone,
        reference: r.slug ? r.slug.toUpperCase() : undefined,
        slug: (_a = r.slug) !== null && _a !== void 0 ? _a : ((_b = r.fullname) !== null && _b !== void 0 ? _b : String(r.id)),
        status: toUIStatus(r),
        request_datetime: (_d = (_c = r.request_datetime) !== null && _c !== void 0 ? _c : r.created_at) !== null && _d !== void 0 ? _d : new Date().toISOString(),
        lat: r.lat,
        long: r.long,
        is_read: r.is_read,
        is_archive: r.is_archive
    };
}
function timeAgo(iso) {
    const d = new Date(iso);
    const diff = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diff < 60)
        return `il y a ${diff}s`;
    if (diff < 3600)
        return `il y a ${Math.floor(diff / 60)} min`;
    if (diff < 86400)
        return `il y a ${Math.floor(diff / 3600)} h`;
    return d.toLocaleDateString();
}
// Styles par statut (inchangés)
const tone = {
    NOUVEAU: { bg: 'bg-info-subtle', border: 'border-info-subtle', chip: 'bg-info-subtle text-info', dot: 'text-primary', left: '#6ea8fe' },
    LU: { bg: 'bg-success-subtle', border: 'border-success-subtle', chip: 'bg-success-subtle text-success', dot: 'text-success', left: '#75b798' },
    TRAITE: { bg: 'bg-warning-subtle', border: 'border-warning-subtle', chip: 'bg-warning-subtle text-warning', dot: 'text-warning', left: '#ffda6a' },
    ARCHIVE: { bg: 'bg-secondary-subtle', border: 'border-secondary-subtle', chip: 'bg-secondary-subtle text-secondary', dot: 'text-secondary', left: '#ced4da' },
};
// ------------------------------------------------------------
// Composant carte stat (inchangé)
// ------------------------------------------------------------
function StatCard({ label, value, symbol, className = '', toneClass = 'info' }) {
    const toneMap = {
        info: { bg: 'bg-info-subtle', text: 'text-info' },
        secondary: { bg: 'bg-secondary-subtle', text: 'text-secondary' },
        success: { bg: 'bg-success-subtle', text: 'text-success' },
        danger: { bg: 'bg-danger-subtle', text: 'text-danger' },
    };
    const t = toneMap[toneClass];
    return (react_1.default.createElement(Card_1.default, { className: `h-100 border rounded-4 ${className}` },
        react_1.default.createElement(Card_1.default.Body, null,
            react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
                react_1.default.createElement("div", { className: `d-inline-flex align-items-center justify-content-center rounded-3 ${t.bg} ${t.text}`, style: { width: 36, height: 36 } }, symbol),
                react_1.default.createElement("div", { className: "ms-1" },
                    react_1.default.createElement("div", { className: "text-muted small" }, label),
                    react_1.default.createElement("div", { className: "fs-2 fw-bold" }, value))))));
}
// ------------------------------------------------------------
// Vue principale NotificationsSOSView
// ------------------------------------------------------------
function NotificationsSOSView({ items, onMarkAllRead, onDeleteRead, onMarkTraite, onArchive, refreshDatas }) {
    const [show, setShow] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const socket = (0, useWebSocket_1.default)();
    // ✅ Remplacement du useEffect socket par useRealtimeChannel
    (0, useRealtimeChannel_1.default)({
        socket,
        channel: "remorquage",
        event: "new.remorquage",
        onMessage: () => {
            // dès qu’un nouvel événement arrive, on recharge les données
            refreshDatas();
        },
    });
    // Préférences utilisateur (inchangées)
    const PREF_ONLY_UNTRAITED = 'notifOnlyUntraitedV1';
    const [onlyUntraited, setOnlyUntraited] = (0, react_1.useState)(() => {
        return localStorage.getItem(PREF_ONLY_UNTRAITED) === '1';
    });
    const toggleOnlyUntraited = () => {
        setOnlyUntraited(prev => {
            const next = !prev;
            localStorage.setItem(PREF_ONLY_UNTRAITED, next ? '1' : '0');
            return next;
        });
    };
    const counts = (0, react_1.useMemo)(() => ({
        LUS: items.filter(i => i.is_read === 1).length,
        ARCHIVES: items.filter(i => i.is_archive === 1).length,
        TRAITES: items.filter(i => i.status === 'traited').length,
        NOUVEAU: items.filter(i => i.status === 'nouveau').length,
        NON_TRAITEES: items.filter(i => i.status !== 'traited').length,
    }), [items]);
    const nonTraiteesCount = counts.NON_TRAITEES;
    const wide = { ['--bs-offcanvas-width']: '780px' };
    (0, useTitleBadge_1.useTitleBadge)(nonTraiteesCount);
    const displayedItems = (0, react_1.useMemo)(() => (onlyUntraited ? items.filter(i => i.status !== 'traited') : items), [items, onlyUntraited]);
    // ----------------------------------------
    // Tout le reste du JSX est inchangé
    // ----------------------------------------
    return (react_1.default.createElement("div", { className: "d-inline-block position-relative" },
        react_1.default.createElement(Button_1.default, { variant: "light", className: "d-inline-flex align-items-center gap-2 rounded-pill px-3 py-2 border header-notification-btn", onClick: () => setShow(true) },
            react_1.default.createElement(io5_1.IoNotificationsOutline, null),
            " ",
            react_1.default.createElement("span", { className: "notification-btn-label" }, "SOS Remorquages"),
            react_1.default.createElement(Badge_1.default, { bg: "primary", pill: true, className: "ms-2 not-read-count-badge" },
                nonTraiteesCount,
                " non trait\u00E9es")),
        react_1.default.createElement(Offcanvas_1.default, { placement: "end", show: show, onHide: () => setShow(false), scroll: true, backdrop: true, style: wide, className: "shadow" },
            react_1.default.createElement(Offcanvas_1.default.Header, { className: "bg-white border-bottom" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Offcanvas_1.default.Title, { className: "fs-4 fw-bold mb-0" }, "Notifications SOS Remorquage"),
                    react_1.default.createElement("div", { className: "text-muted small" }, "Restez inform\u00E9 des derni\u00E8res activit\u00E9s de SOS Remorquage")),
                react_1.default.createElement(CloseButton_1.default, { onClick: () => setShow(false) })),
            react_1.default.createElement(Offcanvas_1.default.Body, { className: "bg-body-tertiary" },
                react_1.default.createElement(Row_1.default, { className: "g-3 mb-3" },
                    react_1.default.createElement(Col_1.default, { xs: 12, lg: 3 },
                        react_1.default.createElement(StatCard, { label: "NON TRAIT\u00C9S", value: counts.NON_TRAITEES, symbol: react_1.default.createElement(fa6_1.FaCarOn, { className: "stat-icon new-icon" }), toneClass: "danger", className: "new-card stat-card" })),
                    react_1.default.createElement(Col_1.default, { xs: 12, lg: 3 },
                        react_1.default.createElement(StatCard, { label: "LUS", value: counts.LUS, symbol: react_1.default.createElement(md_1.MdMarkChatRead, { className: "stat-icon read-icon" }), toneClass: "info", className: "readit-card stat-card" })),
                    react_1.default.createElement(Col_1.default, { xs: 12, lg: 3 },
                        react_1.default.createElement(StatCard, { label: "ARCHIV\u00C9S", value: counts.ARCHIVES, symbol: react_1.default.createElement(bs_1.BsFillArchiveFill, { className: "stat-icon archive-icon" }), toneClass: "secondary", className: "archived-card stat-card" })),
                    react_1.default.createElement(Col_1.default, { xs: 12, lg: 3 },
                        react_1.default.createElement(StatCard, { label: "TRAIT\u00C9S", value: counts.TRAITES, symbol: react_1.default.createElement(fa6_1.FaFileCircleCheck, { className: "stat-icon traited-icon" }), toneClass: "success", className: "traited-card stat-card" }))),
                react_1.default.createElement("div", { className: "d-flex gap-2 mb-3 flex-wrap align-items-center grand-actions-btns-container" },
                    react_1.default.createElement(Button_1.default, { size: "sm", variant: "outline-secondary", className: "rounded-3", onClick: onMarkAllRead }, "\u2705 Tout marquer comme lu"),
                    react_1.default.createElement("div", { className: "form-check form-switch d-inline-flex align-items-center ms-1 filter-untraited-form-check-group" },
                        react_1.default.createElement("input", { className: "form-check-input filter-untraited-form-check", type: "checkbox", id: "onlyUntraitedSwitch", checked: onlyUntraited, onChange: toggleOnlyUntraited }),
                        react_1.default.createElement("label", { className: "form-check-label ms-2 filter-untraited-form-check-label", htmlFor: "onlyUntraitedSwitch" }, "Afficher seulement les non trait\u00E9es"))),
                react_1.default.createElement(ListGroup_1.default, null, displayedItems.map(n => {
                    const t = tone[(n.status === 'nouveau')
                        ? 'NOUVEAU'
                        : (n.status === 'traited')
                            ? 'TRAITE'
                            : (n.is_archive === 1)
                                ? 'ARCHIVE'
                                : (n.is_read === 1)
                                    ? 'LU'
                                    : "NOUVEAU"];
                    return (react_1.default.createElement(ListGroup_1.default.Item, { key: n.id, className: `rounded-4 mb-3 border ${t.bg} ${t.border}`, style: { borderLeft: `6px solid ${t.left}` } },
                        react_1.default.createElement("div", { className: "d-flex align-items-start" },
                            react_1.default.createElement("div", { className: "me-3 mt-1 d-inline-flex align-items-center justify-content-center rounded-3 bg-white border p-2", style: { width: 36, height: 36 } }, "\uD83D\uDE9A"),
                            react_1.default.createElement("div", { className: "flex-grow-1" },
                                react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-start" },
                                    react_1.default.createElement("div", { className: "fw-semibold" },
                                        `Demande du ${n.phone}`,
                                        " ",
                                        n.status === 'nouveau' && react_1.default.createElement("span", { className: "text-primary ms-1", "aria-label": "non lue" }, "\u2022")),
                                    react_1.default.createElement("div", { className: "text-muted small ms-3" }, timeAgo(n.request_datetime))),
                                react_1.default.createElement("div", { className: "mt-2 small text-body" },
                                    "SOS remorquage d\u00E9clench\u00E9 par le num\u00E9ro ",
                                    n.phone),
                                react_1.default.createElement("div", { className: "mt-3 d-flex gap-2 flex-wrap" },
                                    react_1.default.createElement(Button_1.default, { size: "sm", variant: "outline-dark", className: "rounded-3 show-position-btn", onClick: () => navigate(`/admin/sos-remorquage/${n.slug}`) }, "Voir"),
                                    react_1.default.createElement(Button_1.default, { size: "sm", variant: "outline-dark", className: "rounded-3 follow-position-btn", onClick: () => window.open(`https://www.google.com/maps?q=${n.lat},${n.long}`, '_blank') }, "Suivre la position"),
                                    react_1.default.createElement(Button_1.default, { size: "sm", variant: "outline-dark", className: "rounded-3 mark-traited-btn", onClick: () => onMarkTraite(n.id), disabled: n.status === 'traited' }, "Marquer trait\u00E9e"),
                                    react_1.default.createElement(Button_1.default, { size: "sm", variant: "outline-dark", className: "rounded-3 mark-archived-btn", onClick: () => onArchive(n.id), disabled: n.is_archive === 1 }, "Marquer Archiv\u00E9e"),
                                    react_1.default.createElement(Badge_1.default, { bg: "light", text: "dark", className: `ms-auto rounded-pill px-3 ${tone[(n.status === 'nouveau')
                                            ? 'NOUVEAU'
                                            : (n.status === 'traited')
                                                ? 'TRAITE'
                                                : (n.is_archive === 1)
                                                    ? 'ARCHIVE'
                                                    : (n.is_read === 1)
                                                        ? 'LU'
                                                        : "NOUVEAU"].chip}` }, (n.status === 'traited') ? 'TRAITÉ'
                                        : (n.is_archive === 1) ? 'ARCHIVÉ'
                                            : (n.is_read === 1) ? 'LU'
                                                : 'NOUVEAU'))))));
                }))))));
}
// ------------------------------------------------------------
// Container RTK (inchangé)
// ------------------------------------------------------------
function NotificationsSOS_RTK() {
    const { token } = (0, hook_1.useAppSelector)((state) => state.user);
    const unread = (0, sos_notifications_api_1.useListUnreadQuery)();
    const untraited = (0, sos_notifications_api_1.useListUntraitedQuery)();
    const merge = (a = [], b = []) => {
        const map = new Map();
        [...a, ...b].forEach(it => map.set(it.id, it));
        return Array.from(map.values());
    };
    const data = (0, react_1.useMemo)(() => {
        const merged = merge(unread.data, untraited.data);
        return [...merged].sort((a, b) => { var _a, _b; return ((_a = b === null || b === void 0 ? void 0 : b.id) !== null && _a !== void 0 ? _a : 0) - ((_b = a === null || a === void 0 ? void 0 : a.id) !== null && _b !== void 0 ? _b : 0); });
    }, [unread.data, untraited.data]);
    const items = (0, react_1.useMemo)(() => data.map(mapTowToNotif), [data]);
    const [markRead] = (0, sos_notifications_api_1.useMarkReadMutation)();
    const [treatOne] = (0, sos_notifications_api_1.useTreatOneMutation)();
    const [archiveOne] = (0, sos_notifications_api_1.useArchiveOneMutation)();
    const onMarkAllRead = () => __awaiter(this, void 0, void 0, function* () {
        const ids = items.filter(i => i.is_read !== 1).map(i => i.id);
        if (!ids.length)
            return;
        yield axios_1.default.get(`${http_1.ApiBaseUrl}towings-sos/mark-read-bulk`, {
            params: { ids },
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
            },
        });
        unread.refetch();
        untraited.refetch();
    });
    const onDeleteRead = () => __awaiter(this, void 0, void 0, function* () {
        const lus = items.filter(i => i.is_read === 1);
        yield Promise.all(lus.map(n => archiveOne(n.id)));
        unread.refetch();
        untraited.refetch();
    });
    const onMarkTraite = (id) => __awaiter(this, void 0, void 0, function* () {
        yield treatOne(id);
        unread.refetch();
        untraited.refetch();
    });
    const onArchive = (id) => __awaiter(this, void 0, void 0, function* () {
        yield archiveOne(id);
        unread.refetch();
        untraited.refetch();
    });
    const refreshDatas = () => __awaiter(this, void 0, void 0, function* () {
        yield unread.refetch();
        yield untraited.refetch();
    });
    return (react_1.default.createElement(NotificationsSOSView, { items: items, onMarkAllRead: onMarkAllRead, onDeleteRead: onDeleteRead, onMarkTraite: onMarkTraite, onArchive: onArchive, refreshDatas: refreshDatas }));
}
